import React from 'react';
import styled from 'astroturf/react';

import $image_url from 'js/utils/image_url';
import { currentUser } from 'js/utils/user';
import DoubleDigitCountBubble from 'js/header/FocusedNav/DoubleDigitCountBubble';

const PositionedDoubleDigitCountBubble = styled(DoubleDigitCountBubble)`
  position: absolute;
  top: 2px;
  right: -10px;
`;

const UserButton = styled.button<{ small?: boolean }>`
  position: relative;
  height: 42px;
  padding: 0;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  background: transparent;
  border: none;
  color: #0645b1;
  cursor: pointer;

  &:hover,
  &:active,
  &:visited {
    color: #0645b1;
  }
  &:hover,
  &:focus {
    background: transparent;
    color: #0645b1;
  }

  display: flex;
  align-items: center;
`;

const ButtonProfilePic = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 50%;
`;

type Props = {
  count: number;
  menuOpen: boolean;
  setMenuOpen: (openness: boolean) => void;
};

const AccountMenuButton = ({ count, menuOpen, setMenuOpen }: Props) => {
  const toggle = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <UserButton onClick={toggle} aria-pressed={menuOpen}>
      {currentUser != null && (
        <ButtonProfilePic src={$image_url(currentUser.photo)} />
      )}
      <PositionedDoubleDigitCountBubble count={count} />
    </UserButton>
  );
};

export default AccountMenuButton;
